/**
 * Enum for Payment Processor Code
 * @readonly
 * @enum {string}
 */
const ProcessorCode = {
    IDEAL: "DRWP",
    PAYPAL: "PPAL",
    SPRNT: "SPRNT",
    SECURE_3D: "NG",
    SECURE_3D_MY: "DPS",
    SPEED_ORDER: "SPEED",
    ASIAP: "ASIAP",
    PAYU: "PAYU",
    DIRECTDEBIT: "TWKY",
    KLIK: "KLIK",
    PERMATA: "PERMATA",
    MAXXPAY: "MAXX"
};

export default ProcessorCode;
